var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.sourcingSubmitHeadInfo,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SourcingSubmit,
                          expression: "SourcingSubmit",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.sourcingSubmit },
                    },
                    [_vm._v("提交")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.goBack } },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.sourcingNo"),
                            prop: "sourcingNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.sourcingNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "sourcingNo",
                                  $$v
                                )
                              },
                              expression: "sourcingSubmitHeadInfo.sourcingNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.subject"),
                            prop: "subject",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.subject,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "subject",
                                  $$v
                                )
                              },
                              expression: "sourcingSubmitHeadInfo.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.applyType"),
                            prop: "applyType",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.applyTypeI18n,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "applyTypeI18n",
                                  $$v
                                )
                              },
                              expression:
                                "sourcingSubmitHeadInfo.applyTypeI18n",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.quotationType"),
                            prop: "quotationType",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value:
                                _vm.sourcingSubmitHeadInfo.quotationTypeI18n,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "quotationTypeI18n",
                                  $$v
                                )
                              },
                              expression:
                                "sourcingSubmitHeadInfo.quotationTypeI18n",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.createBy"),
                            prop: "userName",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.userName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "userName",
                                  $$v
                                )
                              },
                              expression: "sourcingSubmitHeadInfo.userName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.createDate"),
                            prop: "applyCcreateDate",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.applyCreateDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "applyCreateDate",
                                  $$v
                                )
                              },
                              expression:
                                "sourcingSubmitHeadInfo.applyCreateDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.supplierCode"),
                            prop: "supplierCodes",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.supplierCodes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "supplierCodes",
                                  $$v
                                )
                              },
                              expression:
                                "sourcingSubmitHeadInfo.supplierCodes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("quoteByLine.sourcing.applyNo"),
                            prop: "applyNo",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.sourcingSubmitHeadInfo.applyNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.sourcingSubmitHeadInfo,
                                  "applyNo",
                                  $$v
                                )
                              },
                              expression: "sourcingSubmitHeadInfo.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "sourcingSubmitDialogData",
              attrs: {
                data: _vm.sourcingSubmitDialogData,
                "keep-source": "",
                "max-height": "550",
                "highlight-current-row": "",
                "row-class-name": _vm.rowClassName,
                "show-overflow": "tooltip",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("ux-table-column", {
                attrs: { align: "center", type: "checkbox", width: "80" },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "序号",
                  type: "index",
                  width: "60",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.finalSupplier"),
                  field: "supplierName",
                  "min-width": "200",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.pickupPoint"),
                  field: "pickupPoint",
                  "min-width": "180",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.dc"),
                  field: "dcName",
                  "min-width": "200",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.temperature"),
                  field: "temperatureI18n",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.transportaionMethod"),
                  field: "transportaionMethodI18n",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.unit"),
                  field: "unitI18n",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.effectiveBeginDate"),
                  field: "effectiveBeginDate",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatFilter")(
                                scope.row.effectiveBeginDate,
                                "YYYY-MM-DD"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.price"),
                  field: "price",
                  "min-width": "140",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.currentSupplier"),
                  field: "supplierName",
                  "min-width": "160",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.currentPrice"),
                  field: "formalPrice",
                  "min-width": "160",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.currencyCode"),
                  field: "currencyCode",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: "Leadtime",
                  field: "leadTime",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: "线路类型",
                  field: "lineTypeI18n",
                  "min-width": "100",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  sortable: "",
                  resizable: "",
                  title: _vm.$t("quoteByLine.sourcing.remarks"),
                  field: "remarks",
                  "min-width": "100",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }